interface LoadingProps {
  type?: 'small' | 'normal';
}

const Loading = (props: LoadingProps) => {
  const { type = 'normal' } = props;
  if (type == 'small') {
    return (
      <div className="loadingSmall-spinner-rolling">
        <div className="loadingSmall">
          <div></div>
        </div>
      </div>
    );
  }
  return (
    <div className="loading-spinner-rolling">
      <div className="loading">
        <div></div>
      </div>
    </div>
  );
};

export default Loading;
